<template>
  <div class="page-container">
    <div class="page-title">
      <img src="../../assets/images/activity/turntable/title.png" />
    </div>

    <div class="page-times center">
      您已抽奖:<span style="color: #ffee9d; padding-left: 4px">{{ times }}次</span>，今日还剩:<span style="padding-left: 4px">{{ 10 - times }}次</span>机会
    </div>

    <!-- 转盘 -->
    <div class="page-turntable">
      <div class="turntable-content">
        <div class="turntable-list">
          <div class="turntable-list-item" v-for="(item, index) in prizeList" :key="index" :style="item.style">
            <div class="item-name" :class="{ 'font-large': !item.itemImageUri }">{{ item.prizeTypeName }}</div>
            <div class="item-img" v-if="item.itemImageUri">
              <img :src="item.itemImageUri" />
            </div>
          </div>
        </div>
      </div>

      <!-- 抽奖按钮 -->
      <div class="turntable-btn" @click="clickDraw" :style="rotateStyle">
        <img src="../../assets/images/activity/turntable/table_btn.png" />
      </div>
    </div>

    <div class="page-integral center">
      现有易加积分:<span style="color: #ffee9d; padding-left: 4px">{{ pointValue }}积分</span>
    </div>

    <!-- 按钮 -->
    <div class="page-btn">
      <div class="btn-box" @click="showPop('rule')">活动规则</div>
      <div class="btn-box" @click="showPop('record')">中奖记录</div>
    </div>

    <div class="page-msg-small center">
      *奖品发放形式：积分实时到帐，实物奖品随未发货订单一起寄出
    </div>

    <div class="page-title-sub">
      <img src="../../assets/images/activity/turntable/title_2.png" />
    </div>

    <div class="page-msg center" style="margin-top: 8px">
      每个种类券限领取一张，有效期30天
    </div>

    <!-- 领券 -->
    <TurntableCoupon class="page-coupon" :lotteryTimes="lotteryTimes" :tookCouponList="tookCouponList"/>

    <div class="page-msg center">*活动最终解释权归易加网所有</div>

    <div class="page-footer">
      <img src="../../assets/images/activity/turntable/bottom.png" />
    </div>

    <!-- 弹窗 - 说明与列表 -->
    <van-popup v-model="popShow" class="turntable-pop" :close-on-click-overlay="false" closeable>
      <div class="pop-title">
        {{ popType === "rule" ? "活动规则" : "中奖记录" }}
      </div>

      <!-- 活动规则 -->
      <div v-if="popType === 'rule'">
        <div class="pop-content">
          <span class="pop-content-label">活动时间：</span>
          <span>2020.5.11至2020.5.15；</span>
        </div>
        <div class="pop-content">
          <span class="pop-content-label">参与对象：</span>
          <span>博世易加网IAM用户；</span>
        </div>
        <div class="pop-content">
          <span class="pop-content-label">活动说明：</span>
          <span>活动期间消耗易加积分88积分（非特殊积分）获得抽奖机会一次，每日有10次抽奖机会；</span>
        </div>
        <div class="pop-content">
          <div class="pop-content-label">奖品发放形式：</div>
          <div>实物奖：随未发货积分订单一起发出；</div>
          <div>积&nbsp;&nbsp;&nbsp;&nbsp;分：实时到账（非特殊积分）</div>
          <div>抵扣券：点击领取后实时到账，有效期为30天。</div>
        </div>
      </div>

      <!-- 中奖记录 -->
      <div v-else class="record-list">
        <div class="record-list-row list-title" v-if="recordList.length">
          <div class="record-list-time">中奖时间</div>
          <div class="record-list-detail">奖品明细</div>
        </div>
        <div class="record-list-box" v-if="recordList.length">
          <div class="record-list-row" v-for="(item, index) in recordList" :key="index">
            <div class="record-list-time">
              {{ item.attendTime | parseTime("{y}-{m}-{d} {h}:{i}:{s}") }}
            </div>
            <div class="record-list-detail">{{ item.prizeTypeName }}</div>
          </div>
        </div>
        <div v-else style="text-align: center; margin-top: 20px">
          暂无中奖记录
        </div>
      </div>
    </van-popup>

    <!-- 弹窗 - 中奖 -->
    <van-popup v-model="popShowPrize" class="prize-pop" :close-on-click-overlay="false" closeable>
      <div class="pop-title">{{ prizeIndex ? "中奖啦~!" : "啊哦~!" }}</div>

      <div class="pop-msg" v-if="prizeIndex">获得{{ prizeList[prizeIndex].prizeTypeName }}</div>
      <div class="pop-msg" v-else>您与奖品擦肩而过</div>

      <div class="pop-img">
        <img :src="prizeList[prizeIndex].itemImageUri" v-if="prizeIndex"/>
        <img src="../../assets/images/activity/turntable/no_prize.png" v-else/>
      </div>

      <div class="pop-msg" v-if="prizeIndex">亲，人品爆发啦</div>
      <div class="pop-msg" v-else>大奖还在等着你哦</div>

      <div class="pop-btn" @click="drawAgain">再来一次</div>
    </van-popup>
  </div>
</template>

<script>
import TurntableCoupon from './components/turntable-coupon'

import activityApi from '../../api/activity'

import { userUtils } from '@/utils/auth'
import { commonUtils } from '@/utils/common'

export default {
  name: 'ActivityTurntable',
  components: {
    TurntableCoupon
  },
  data () {
    return {
      times: 0,
      pointValue: 0,
      popShow: false,
      popShowPrize: false,
      popType: '',
      lotteryTimes: null,
      tookCouponList: [],
      prizeList: [],
      recordList: [],
      angleList: [],
      isRotating: true,
      config: {
        // 总旋转时间
        duration: 3000,
        // 旋转圈数
        circle: 10,
        mode: 'linear'
      },
      rotateAngle: 0, // 旋转角度
      prizeIndex: 0,
      bStop: false,
      pointValueTemp: 0
    }
  },

  computed: {
    rotateStyle () {
      return `
        transition: transform ${this.config.duration}ms ${this.config.mode};
        transform: rotate(${this.rotateAngle}deg);`
    }
  },

  created () {
    this.clientInfo = userUtils.getClientInfo()
    if (!this.clientInfo) {
      window.location.href = commonUtils.getExtraSite() + '/#/login'
    }

    this.getPrizeList()
  },

  methods: {
    showPop (type) {
      this.popType = type
      this.popShow = true

      if (type === 'record') {
        this.getRecordList()
      }
    },

    // 获取奖品类型
    getPrizeList () {
      this.$toast.loading({
        message: '加载中...',
        forbidClick: true,
        loadingType: 'spinner',
        duration: 0
      })
      activityApi.getPrizeList().then(res => {
        this.$toast.clear()
        if (res.data.resultCode === '0') {
          this.isRotating = false
          this.prizeList = res.data.resultData.prizeList
          this.lotteryTimes = res.data.resultData.totalCount
          this.times = res.data.resultData.todayCount
          this.pointValue = res.data.resultData.pointValue
          this.tookCouponList = res.data.resultData.tookCouponList
          this.setPrizeImg()
          this.formatPrizeList()
        }
      }).catch(() => {
        this.$toast.clear()
      })
    },

    // 设置奖品图片
    setPrizeImg () {
      this.prizeList.forEach(item => {
        let imgUrl = ''
        if (item.pointValue === 888) {
          imgUrl = require('../../assets/images/activity/turntable/prize_1.png')
        }
        if (item.pointValue === 3600) {
          imgUrl = require('../../assets/images/activity/turntable/prize_2.png')
        }
        if (item.pointValue === 4800) {
          imgUrl = require('../../assets/images/activity/turntable/prize_3.png')
        }
        if (item.pointValue === 18900) {
          imgUrl = require('../../assets/images/activity/turntable/prize_4.png')
        }
        if (item.pointValue === 34500) {
          imgUrl = require('../../assets/images/activity/turntable/prize_5.png')
        }
        this.$set(item, 'itemImageUri', imgUrl)
      })
    },

    // 格式化轮盘
    formatPrizeList () {
      const prizeNum = this.prizeList.length
      const average = 360 / prizeNum
      this.prizeList.forEach((item, index) => {
        const angle = -(index * average)
        this.$set(item, 'style', `transform: rotate(${angle}deg);`)
        this.angleList.push(index * average)
      })
      // console.log(this.angleList)
    },

    // 获取中奖记录
    getRecordList () {
      this.$toast.loading({
        message: '加载中...',
        forbidClick: true,
        loadingType: 'spinner',
        duration: 0
      })
      activityApi.getRocordList().then(res => {
        this.$toast.clear()
        if (res.data.resultCode === '0') {
          this.recordList = res.data.resultData.recordList
        }
      }).catch(() => {
        this.$toast.clear()
      })
    },

    // 点击抽奖
    clickDraw () {
      if (this.isRotating) {
        return
      }
      if (this.times === 10) {
        this.$toast({
          message: '今日抽奖次数已用完'
        })
        return
      }

      this.prizeIndex = 0
      this.bStop = false
      this.config.mode = 'linear'
      const angle = this.rotateAngle + this.config.circle * 360
      this.rotateAngle = angle
      this.rotating()

      activityApi.clickDraw().then(res => {
        if (res.data.resultCode === '0') {
          this.lotteryTimes = res.data.resultData.totalCount
          this.times = res.data.resultData.todayCount
          this.pointValueTemp = res.data.resultData.pointValue
          if (!res.data.resultData.drawResult.pointValue) {
            this.prizeIndex = 0
          }
          this.prizeList.forEach((item, index) => {
            if (item.pointValue === res.data.resultData.drawResult.pointValue) {
              this.prizeIndex = index
            }
          })
          this.bStop = true
        }
      })
    },

    rotating () {
      this.isRotating = true
      console.log(new Date().getTime())
      // 计算角度
      // const angle = this.rotateAngle + this.config.circle * 360 - this.angleList[this.prizeIndex] - (this.rotateAngle % 360)
      setTimeout(() => {
        // this.isRotating = false
        if (this.bStop) {
          this.rotateAngle = this.rotateAngle + (this.config.circle - 3) * 360 - this.angleList[this.prizeIndex] - (this.rotateAngle % 360)
          this.config.mode = 'ease-out'
          setTimeout(() => {
            this.isRotating = false
            this.popShowPrize = true
            this.pointValue = this.pointValueTemp
          }, 3500)
        } else {
          this.rotateAngle = this.rotateAngle + this.config.circle * 360
          this.rotating()
        }
      }, this.config.duration)
    },

    // 再来一次
    drawAgain () {
      this.popShowPrize = false
      setTimeout(() => {
        this.clickDraw()
      }, 400)
    }
  }
}
</script>

<style lang="less" scoped>
.page-container {
  background-color: #22545b;
  box-sizing: border-box;
  color: #fff;

  img {
    width: 100%;
    height: auto;
  }

  .page-times {
    font-size: 16px;
    margin-top: 12px;
  }

  .page-turntable {
    width: 360px;
    height: 360px;
    margin: 15px auto;
    // background: url("../../assets/images/activity/turntable/plate.png") no-repeat;
    box-sizing: border-box;
    position: relative;

    .turntable-content {
      position: absolute;
      top: 0;
      left: 0;
      z-index: 1;
      width: 100%;
      height: 100%;
      background: url("../../assets/images/activity/turntable/plate.png") no-repeat;
      background-size: 100%;
      color: #ff3939;

      div {
        text-align: center;
      }

      .turntable-list {
        width: 100%;
        height: 100%;
        position: relative;

        .turntable-list-item {
          position: absolute;
          width: 90px;
          height: 180px;
          top: 0;
          left: 50%;
          box-sizing: border-box;
          margin-left: -47.5px;
          padding-top: 50px;
          transform-origin: 50% 100%;

          .item-img {
            width: 40px;
            height: 40px;
            margin: 10px auto 0 auto;

            img {
              width: auto;
              height: 100%;
            }
          }
        }
      }
    }

    .turntable-btn {
      width: 90px;
      height: 90px;
      position: absolute;
      top: 135px;
      left: 135px;
      z-index: 2;
      border-radius: 90px;
      overflow: hidden;

      img {
        width: 100%;
        height: 100%;
      }
    }
  }

  .page-btn {
    display: flex;
    align-items: center;
    justify-content: center;
    box-sizing: border-box;

    .btn-box {
      width: 140px;
      height: 32px;
      line-height: 32px;
      border-radius: 6px;
      color: #22545b;
      font-size: 16px;
      margin: 18px 8px;
      text-align: center;
      background-color: #fff;
    }
  }

  .page-msg-small {
    font-size: 10px;
  }

  .page-title-sub {
    width: 215px;
    margin: 50px auto 0 auto;
  }

  .page-coupon {
    margin-top: 30px;
  }

  .page-msg {
    margin-top: 20px;
    font-size: 12px;
  }

  .page-footer {
    margin-top: 50px;
  }

  .center {
    text-align: center;
  }

  .turntable-pop {
    width: 300px;
    height: 370px;
    border-radius: 10px;
    box-sizing: border-box;
    padding: 30px 18px;
    color: #000;
    overflow: hidden;

    .pop-title {
      font-size: 18px;
      font-weight: bold;
      text-align: center;
    }

    .pop-content {
      margin-top: 18px;
      line-height: 20px;

      .pop-content-label {
        font-weight: bold;
      }
    }

    .record-list-row {
      display: flex;
      align-items: center;
      margin-top: 10px;
      justify-content: space-between;

      .record-list-time {
        width: 55%;
        text-align: center;
      }

      .record-list-detail {
        width: 45%;
        text-align: center;
      }
    }

    .record-list-box {
      height: 250px;
      overflow-y: auto;
      margin: 10px;
      font-size: 12px;

      .more-data {
        text-align: center;
        margin-top: 15px;
      }
    }

    .list-title {
      font-size: 14px;
      font-weight: bold;
      margin-top: 15px;
    }
  }

  .prize-pop {
    width: 260px;
    height: 340px;
    border-radius: 10px;
    box-sizing: border-box;
    color: #000;
    overflow: hidden;
    text-align: center;
    padding-top: 40px;

    .pop-title {
      font-size: 24px;
      font-weight: bold;
    }

    .pop-msg {
      margin-top: 15px;
    }

    .pop-img {
      width: 100px;
      height: 100px;
      margin: 20px auto;

      img {
        width: auto;
        height: 100%;
      }
    }

    .pop-btn {
      width: 180px;
      height: 35px;
      color: #fff;
      margin: 20px auto;
      line-height: 35px;
      text-align: center;
      border-radius: 4px;
      background-color: #30747d;
    }
  }

  .rotate-style {
    transition: transform 1000ms linear;
    transform: rotate(360deg);
  }

  /deep/ .van-popup__close-icon--top-right {
    top: 10px;
    right: 10px;
  }

  .font-large {
    font-size: 22px;
    padding-top: 20px;
  }
}
</style>
